import { z } from 'zod';
import { QuerySpecSchema } from './metrics-catalog.js';
import { AnalysisKindSchema } from './product-analysis.js';
export const AnalysisHistorySearchSchema = z.object({
    page: z.coerce.number().int().min(1).max(100000).default(1),
    q: z.string().trim().max(200).default(''),
});
export const AnalysisHistoryItemSchema = z.object({
    id: z.string(),
    question: z.string(),
    createdAt: z.string().datetime(),
    status: z.enum(['analysis', 'resolved', 'missing', 'recorded']),
    model: z.string().nullable(),
    kind: AnalysisKindSchema.nullable(),
    latencyMs: z.number().nonnegative(),
});
export const AnalysisHistoryPageSchema = z.object({
    items: z.array(AnalysisHistoryItemSchema),
    total: z.number().int().nonnegative(),
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
});
export const AnalysisHistoryDetailSchema = AnalysisHistoryItemSchema.extend({
    query: QuerySpecSchema.nullable(),
    reason: z.string().nullable(),
    answerStored: z.literal(false),
});
//# sourceMappingURL=analysis-history.js.map